import { AfterViewInit, Component, EventEmitter, Inject, KeyValueDiffers, OnInit, Output } from '@angular/core';
import { async } from '@angular/core/testing';
import {FormGroup, FormControl} from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { Chuva } from '../models/chuva';
import { Localidade } from '../models/localidade';
import { Tempo } from '../models/tempo';
import { Session } from '../models/session';
import { Iteration } from '../models/iteration';
import { ServiceService } from '../services/service.service';
import { GeoJSON, Point } from 'geojson';
import { TryCatchStmt } from '@angular/compiler';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';
import { finalize } from 'rxjs/operators';
import { HeatmapType } from '../models/heatmap-type';
import { ColorType } from '../models/color-type';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Alerta } from '../models/alerta';
import { EventsConfig } from '../models/events-config';
import { MapConfig } from '../models/map-config';
import { DashboardToMapService} from 'src/app/dashboard/services/dashboard-to-map-service.service';
import { Analise } from '../../dashboard/models/analise';
import { MathAux } from '../services/math-aux/math-aux';
import { routerToMainService } from '../services/routerToMainService';
import { TimespanService } from '../services/timespan/timespan.service';
import { HeuristicService } from '../../routes/services/heuristic/heuristic.service';
import { VoronoiService } from '../services/voronoi/voronoi.service';
import { VoronoiEventsCount } from '../models/voronoi-events-count';
import { StartableFromRouter } from 'src/app/dashboard/models/startable-from-router';
import { TimeFormatter} from 'src/app/instant-analysis/utils/time-formatter'
import { SocketIoServerService } from '../services/socket-io-server/socket-io-server.service';
import { TimeFormatterService } from 'src/app/shared/util/time-formatter';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';
import { SaveAnalysisResponse } from 'src/app/mainmenu/models/save-analysis-response';


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, StartableFromRouter {
  menuIndex: number = null;
  opened = false;

  selected = "30";
  selectedHeatmapType = 2;

  /** Informa se as camadas estão ativas ou não.
   * - 0: estações
   * - 1: heatmap
   * - 2: vias
   * - 3: rios
   */
  heatmaptype = [false,false,true,false];

  /** vetor que contém [dia, mes, ano, hora, minuto] de agora */
  now = TimeFormatter.getNow();

  /** Data do instante cuja chuva será analisada. */
  startDate = (this.now[2] + "-" + this.now[1] + "-" + this.now[0]) ;

  /** Hora do instante cuja chuva será analisada. */
  startTime = this.now[3] + ":" + this.now[4];

  /** Data limite da janela de ocorrências registradas a partir da data 
   * do instante de chuva. */
  endDate = this.now[2] + "-" + this.now[1] + "-" + this.now[0];

  /** Hora limite da janela de ocorrências registradas a partir da data
   * do instante de chuva. */
  endTime = this.now[3] + ":" + this.now[4];

  /** */
  dataImportedSubscription: Subscription;

  /** Observable da busca das sessões da heurística do cálculo das rotas. */
  Sessions$: Observable<Session[]>;

  /** */
  Iterations$: Observable<Iteration[]>;

  /** Valor do campo de tamanho da célula para a grade do heatmap */
  tilesize = 0.1;

  /** Horas do intervalo de tempo de ocorrências. */
  intervalo = 24;

  /** Minutos do intervalo de tempo de ocorrências. */
  minutosOcorrencia = 0;

  /** Percentis inferior e superior */
  percentil = [10,90];

  /** Opções para o select da fonte dos dados. */
  dataSourceOptions = [
    { 'text': 'Todas', 'value': ['PREFEITURA NITERÓI', 'CEMADEN'] },
    { 'text': 'Prefeitura de Niterói', 'value': ['PREFEITURA NITERÓI'] },
    { 'text': 'CEMADEN', 'value': ['CEMADEN'] },
  ];

  /** Fonte dos dados: prefeitura, cemaden, ou ambos. */
  dataSource: string[] = this.dataSourceOptions[0].value;

  /** Indica se a atualização do mapa em tempo real está ligada ou não. */
  enabledRT = false;

  /** Nome da coluna do agregado de chuva selecionada. */
  timestamp = "indice_pluv";

  /** Objeto que armazena as configurações do mapa, como camadas ativas, tipo
   * de coloração das camadas, percentis etc.
   */
  mapConfig : MapConfig = this.mapConfigService.instantMapConfig;
  
  // Variáveis para a recuperação do histórico de rotas
  /** */
  selectedSession: number;

  /** */
  sessionList: Session[] = [];

  /** */
  iterationList: Iteration[] = [];
  
  /** */
  showHistoryRoutes: boolean = true;

  /** */
  showCurrentRoutes: boolean = true;

  // Variáveis de heurística

  /** */
  currentIterations: number[] = [];

  /** Prioridades das ocorrências */
  priorityList = [
    'Desabamento',
    'Alagamento',
    'Deslizamento',
  ];

  /** Configuração de cor das camadas. Índices definidos de acordo com HeatmapType
   * - 0: estações
   * - 1: heatmap
   * - 2: vias
   * - 3: rios
   * - 4: bairros
   * - 5: voronoi
   * - 6: ocorrências
   * - 7: câmeras
   */
  heatmapConfig = [
    { id: 1, layerType: 1, colorType: ColorType.DISCRETE, },
    { id: 2, layerType: 1, tilesizeInKm: this.tilesize, colorType: ColorType.CONTINUOUS, },
    { id: 3, layerType: 1, colorType: ColorType.DISCRETE, },
    { id: 4, layerType: 1, colorType: ColorType.DISCRETE, },
    { id: 5, layerType: 1, colorType: ColorType.DISCRETE},
    { id: 6, layerType: 2, colorType: null },
    { id: 7, layerType: 2, colorType: null },
    { id: 8, layerType: 2, colorType: null },
  ];

  /** Tipo de coloração das camadas selecionada.
   * 1 - contínua
   * 2 - discreta
   */
  highwayType = 2;

  /** Porcentagem de completude dos acumulados de chuva. */
  completeness: number = 0;

  /**
  * Textos do tooltips do toolbar.
  */
  firstTooltipText:string = "Liga a atualização do mapa em tempo real, ou seleciona um instante específico. Define, em horas e minutos, o tamanho da janela de ocorrências.";
  secondTooltipText:string = "Alterna a coloração de cada camada entre contínua e discreta. Define os percentis inferior e superior para a coloração contínua.";
  thirdTooltipText:string = "Determina rotas para atender as ocorrências. Exibe histórico de rotas determinadas.";
  fourthTooltipText:string = "Filtra estações pela completude e pela fonte dos dados.";
  fifthTooltipText:string = "Salva as configurações atuais do mapa e das camadas como uma análise.";

  /** Emite o evento de fechamento da barra lateral. */
  @Output() close = new EventEmitter<boolean>();

  /** Emite o evento da obtenção do resultado da heurística */
  @Output() callHeuristic = new EventEmitter<any>();

  /** */
  @Output() getHistoryGeometries = new EventEmitter<any>();

  /** */
  @Output() clearAllRoutes = new EventEmitter<any>();

  /** */
  @Output() changeVisibilityHistoryLayer = new EventEmitter<any>();

  /** */
  @Output() changeVisibilityCurrentLayer = new EventEmitter<any>();

  /** */
  @Output() menuIndexChanged = new EventEmitter<number>();

  /** Evento de uma busca de dados nova. Associado ao botão Confirmar Mudanças na parte do tempo. */
  @Output() newTimeSearch = new EventEmitter<MapConfig>();

  /** Evento de alteração do mapa sem buscar dados novos. Associado aos campos da toolbar. */
  @Output() mapConfigChanged = new EventEmitter<MapConfig>();

  /** Evento de novos alertas inseridos no banco de dados pelo script python de carregamento em tempo real. */
  @Output() newAlertsAvailable = new EventEmitter<void>();

  /** Evento de exportação do mapa. */
  @Output() mapExported = new EventEmitter<void>();

  /** Evento de busca das execuções da heurística das rotas. */
  @Output() iterationsLoaded = new EventEmitter<Iteration[]>();

  /** Evento de click no botão para abrir a tabela do histórico de iterações da heurística das rotas */
  @Output() routeIterationHistoryTableOpened = new EventEmitter<void>();

  /** Indica se a barra lateral está ativa ou não. */
  isToolbarActive = false;
  
  /** Indica se a heurística está executando, para controlar a exibição da barra de progresso. */
  isHeuristicRunning = false;

  constructor(
    protected service: ServiceService, 
    protected overlay: Overlay,
    protected snackBar: MatSnackBar,
    protected routerMessager: routerToMainService, 
    protected heuristicService: HeuristicService,
    protected dataImportedListener: SocketIoServerService,
    protected timeFormatterService: TimeFormatterService,
    protected mapConfigService: MapConfigService) { }

  ngOnInit(): void {
  }

  /**
   * Ativa ou desativa a busca de registros em tempo real.
   * @param event evento de mudança do controle do tempo real.
   */
  onRealTimeChange(event: any) {

    if (this.dataImportedSubscription) {
      this.dataImportedSubscription.unsubscribe();
    }

    if (this.mapConfig.time.enabledRealTime === false) {
      return;
    }

    const parseBool = (val: string) => JSON.parse(val.toLowerCase());

    // Mudar o valor dos campos para data e hora atual.
    this.setTimeFieldsToNow();
    this.updateMap(true);
    
    // Ligar ouvinte do socket.io para receber atualizações de dados importados
    // pelo script de tempo real do python.
    // Quando receber uma atualização, disparar a atualização do mapa.
    this.dataImportedSubscription = this.dataImportedListener
      .getNewMessage()
      .subscribe(([importedRain, importedAlerts]) => {

        this.setTimeFieldsToNow();

        if (parseBool(importedRain) === true) {
          this.updateMap(true);
          return;
        }

        if (parseBool(importedAlerts) == true) {
          this.newAlertsAvailable.emit();
        }
      });
  }

  /**
   * Atualiza os valores dos campos de data e hora inicial e final.
   */
  setTimeFieldsToNow() {

    let [date, time] = this.timeFormatterService.dateParts(new Date());
    this.mapConfig.time.startDate = date;
    this.mapConfig.time.startTime = time;

    let end = new Date();
    end.setMinutes(end.getMinutes() + this.minutosOcorrencia + this.intervalo * 60);

    let [finalDate, finalTime] = this.timeFormatterService.dateParts(end);
    this.mapConfig.time.endDate = finalDate;
    this.mapConfig.time.endTime = finalTime;
  }

  /**
   * Retorna os dados de rotas que já foram geradas em seções anteriores
   * 
   * @param firstRequest indica que é a primeira requisição de dados, logo quando a página é aberta
   * @returns retorna com uma mensagem na tela se não houver histórico ainda
   */
  getSessionList(dia: number, mes: number, ano: number) {
    this.Sessions$ = this.service.getSessionList(dia, mes, ano);
    this.Sessions$.subscribe(val => {
      this.sessionList = val;
      
      if (this.sessionList.length > 0) {
        this.selectedSession = this.sessionList[0].id;
        this.getIterationList(this.selectedSession);
      } else {
        this.selectedSession = 0;
        this.iterationList = [];
        this.clearRoutes();
      }
    });
  }

  /**
   * Busca as iterações relacionadas a uma sessão da heurística.
   * @param session_id id da sessão cujas iterações serão buscadas.
   */
  getIterationList(session_id: number) {
    this.Iterations$ = this.service.getIterationList(session_id);
    this.Iterations$.subscribe(val => {
      this.iterationList = val;
      this.iterationsLoaded.emit(val);
    });
  }

  /**
   * É chamado quando se quer buscar novos dados do banco de dados para mandar pro mapa
   * 
   * @param newSearch diz se é uma busca completamente nova ou não 
   * @returns retorna com uma mensagem na tela se certos parâmetros da toolbar não forem acatados
   */
  updateMap(newSearch: boolean){

    this.updateEndDateTimeField();

    if(! this.isFormValid()) return

    // this.showBackdrop();

    // let mapConfig: MapConfig = {
    //   newSearch,
    //   startDatetime: this.getStartDatetimeStr(),
    //   endDatetime: this.getEndDatetimeStr(),
    //   tilesize: this.tilesize,
    //   percentile: this.percentil,
    //   highwayTypes: this.getColorTypes(),
    //   selectedTimestamp: this.timestamp,
    //   firstStations: {estacao: false, interpolado: false, vias: false, rios: false},
    //   dataSource: this.dataSource,
    //   completeness: 0,
    // };

    this.newTimeSearch.emit();

    return;
  }

  /**
   * 
   */
  updateEndDateTimeField() {
    let { eventIntervalInHours, eventIntervalInMinutes, startDatetime } = this.mapConfig.time;
    let endDateTime = new Date(startDatetime);
    endDateTime.setMinutes(endDateTime.getMinutes() + eventIntervalInHours * 60 + eventIntervalInMinutes);

    let [endDate, endTime] = this.timeFormatterService.dateParts(endDateTime);
    this.mapConfig.time.endDate = endDate;
    this.mapConfig.time.endTime = endTime;
  }

    /**
     * Alterna entre exibir / esconder a toolbar
     */
    toggleToolbar() {
      this.isToolbarActive = ! this.isToolbarActive;
    }

    /**
     * Verifica se é possível exibir o campo de entrada do tilesize (tamanho da célula da grade do heatmap em km).
     * A condição é satisfeita quando o usuário seleciona a opção "Heatmap" no campo "selectedHeatmapType".
     *
     * @returns indica se é possível exibir o campo do tilesize ou não.
     */
    canSetTileSize(): boolean {
      return this.selectedHeatmapType == HeatmapType.HEATMAP;
    }

    /**
     * Verifica se é possível exibir o campo de entrada do tilesize (tamanho da célula da grade do heatmap em km).
     * A condição é satisfeita quando o usuário seleciona a opção "Heatmap" no campo "selectedHeatmapType".
     *
     * @returns indica se é possível exibir o campo do tilesize ou não.
     */
     canSetIntervalo(): boolean {
      return this.selectedHeatmapType == 5;
    }

    /**
     * Verifica se é possível exibir os campos de entrada dos percentis mínimo e máximo.
     * A condição é satisfeita quando há pelo menos um tipo de visualização - exceto heatmap (interpolação) -
     * usando cores contínuas.
     * A exceção da visualização do heatmap ocorre porque definimos que os percentis para o heatmap sempre
     * são 10 e 90.
     *
     * @returns indica se é possível exibir os campos dos percentis ou não.
     */
    canSetPercentil() : boolean {
      return  (this.mapConfig.layer.list.find((layer, index) => {
        return layer.color == ColorType.CONTINUOUS
      }) != null && this.selectedHeatmapType != 5);
    }

    /**
     * Verifica se é permitido remover as cores das layers (colorir de cinza).
     * No momento, apenas as layers de linhas das vias e dos rios podem ter as cores removidas.
     *
     * @returns indica se a layer pode ter as cores removidas.
     */
    canResetColor() : boolean {

      return [HeatmapType.HIGHWAYS, HeatmapType.RIVERS, HeatmapType.NEIGHBORHOOD].includes(this.selectedHeatmapType);
    }

    /**
     * Obtém os tipos de coloração (1: contínua; 2: discreta) selecionados para cada tipo de visualização
     * (estações, heatmap, vias e rios).
     *
     * @returns um array contendo o número do tipo de coloração para as visualizações (estações, heatmap, vias, rios),
     *    nesta ordem.
     */
    getColorTypes(): number[] {
      return this.heatmapConfig.map(conf => conf.colorType);
    }

    /**
     * Disparado quando os campos do filtro mudam.
     * Verifica se o id_tempo é 0 antes de chamar o método de busca por dados de chuva.
     * Isso evita que a busca seja disparada quando o usuário só está configurando o filtro no início.
     *
     * @param attr: tipo de atributo do mapconfig a ser mudado
     */
    onFilterChange(attr: string) {

      let { tempo } = this.mapConfig.time;
      if (tempo == null || tempo.length == 0) {
        return;
      }

      if (this.testPercentile() == false) {
        return;
      }

      if (this.testTileSize() == false) {
        return;
      }

      // if(attr == "percentile") this.mapConfig.layer.percentile = this.percentil
      // else if(attr == "heatmapConfig") this.mapConfig.layer.colors = this.getColorTypes()
      // else if(attr == "tilesize") this.mapConfig.layer.tilesizeInKm = this.heatmapConfig[1].tilesizeInKm
      // else if(attr == "source") {
      //   this.mapConfig.dataFilter.dataSource = this.dataSource;
      // }
      // else if (attr == "completeness") {
      //   this.mapConfig.dataFilter.completeness = this.completeness;
      // }

      this.mapConfig.time.newSearch = false;
      this.mapConfigChanged.emit();
    }

    toggleConfigPanel() {
      this.close.emit(false);
    }

    /**
     * Alterna o índice do menu ativo no momento. Também emite o índice do menu ativo.
     * @param index índice do menu ativo
     */
    setMenuIndex(index: number) {
      this.menuIndex = index;
      this.menuIndexChanged.emit(index);
    }

    /**
     * Valida os campos do formulário de filtro da chuva e configuração de camadas.
     * No momento, a validação se aplica aos campos de percentis, ao campo de
     * tilesize, e aos campos de instante de tempo de chuva e limite da janela de
     * ocorrências.
     * @returns true se o formulário estiver inválido, false caso contrário.
     */
    isFormValid() {
      let timeErrorMessage = 'O instante da chuva deve ser anterior ao instante limite das ocorrências';
      return this.testPercentile() && this.testTileSize() && this.testDates(timeErrorMessage);
    }

    /**
     * Verifica se os valores dos campos do percentil inferior e superior estão \
     * nos intervalos corretos. O percentil inferior deve estar entre 0 e 49, \
     * enquanto o percentil superior deve estar entre 51 e 100
     * @returns true se os valores estiverem nos intervalos certos; false, caso contrário.
     */
    testPercentile(){
      let { percentile } = this.mapConfig.layer;
      if (percentile[0] < 0 || percentile[0] > 49 || percentile[1] < 51 || percentile[1] > 100){
        this.snackBar.open("Por favor, inserir valores dentre os limites (0 <= Min <= 49) e (51 <= Max <= 100)","",{duration:3000})
        return false
      } else return true
    }

    /**
     * Verifica se o tamanho da célula da grade do heatmap da chuva está no intervalo permitido.
     * @returns true se o tamanho da célula está entre 0.05 km e 2 km; false, caso contrário.
     */
    testTileSize(){
      let { tilesizeInKm } = this.mapConfig.layer;
      if (tilesizeInKm < 0.05 || tilesizeInKm > 2){
        this.snackBar.open("Por favor, inserir um valor dentro dos limites (0.05 <= x <= 2)","",{duration:3000})
        return false
      } else return true
    }

    /**
     * Verifica se o instante da chuva é menor ou igual ao instante da janela
     * de ocorrências.
     * @returns true se o instante da chuva é menor ou igual ao instante da janela
     *    de ocorrências, ou false, caso contrário.
     */
    testDates(timeErrorMessage: string) {

      let { startDatetime, endDatetime } = this.mapConfig.time;
      let validDates = startDatetime <= endDatetime;

      if (validDates == false) {
        this.snackBar.open(
          timeErrorMessage, 
          null,
          { duration: 6000 }
        );
      }
      return validDates;
    }

    /**
     * Obtém uma string de data usando os campos de data e hora
     * @returns string YYYY-mm-dd HH:MM
     */
    getStartDatetimeStr(): string {
      return `${this.startDate} ${this.startTime}`;
    }

    /**
     * Obtém uma string de data usando os campos de data e hora final
     * @returns string YYYY-mm-dd HH:MM
     */
    getEndDatetimeStr(): string {
      return `${this.endDate} ${this.endTime}`;
    }

    /**
     * Usa uma análise selecionada para inicializar os campos do formulário de filtros e camadas.
     * @implements StartableFromRouter.startFromRouter
     * @param projeto 
     */
    startFromRouter(analise:Analise) {
      this.startDate = analise.data_inicio;
      this.startTime = analise.hora_inicio;
      this.endDate = analise.data_fim;
      this.endTime = analise.hora_fim;

      this.heatmapConfig[1].tilesizeInKm = analise.tilesize
      this.percentil = [analise.percentil_min,analise.percentil_max]
      this.intervalo = analise.intervalo_horas_ocorrencias
      this.minutosOcorrencia = analise.intervalo_minutos_ocorrencias;
      
      // this.heatmapConfig.forEach((val,index)=>{
      //   let camada = analise.camadas.filter(val => (val.id_camada-1) == index)[0]
      //   if (camada != undefined) val.colorType = camada.coloracao as number
      // })
      this.timestamp = analise.coluna_selecionada;
      this.updateMap(true)
    }

    /**
     * 
     * @param response 
     */
    onAnalysisSaved(response: SaveAnalysisResponse) {

      this.snackBar.open(response.message, '', { duration: 6000, });
    }

    /**
     * 
     * @param error 
     */
    onAnalysisSavedError(error: any) {

      this.snackBar.open(error.message, '', { duration: 6000, });
    }

    /**
     * 
     * @param date 
     * @returns 
     */
    private getDateStr(date: Date): string {

      let year = date.getUTCFullYear();
      let month = date.getUTCMonth() + 1;
      let day = date.getUTCDate();
      return `${year}-${month}-${day}`;
    }

    /**
     * 
     * @param date 
     */
    private getTimeStr(date: Date): string {

      let hour = MathAux.LPAD(date.getHours().toString());
      let minute = MathAux.LPAD(date.getMinutes().toString());

      return `${hour}:${minute}`;
    }

    /**
     * Cria um objeto Date a partir dos campos de data e hora.
     * @returns objeto date criado a partir dos campos.
     */
    getDateTime(){
      return new Date(
        parseInt(this.startDate.slice(0,4)),
        parseInt(this.startDate.slice(5,7))-1,
        parseInt(this.startDate.slice(8,10)),
        parseInt(this.startTime.slice(0,2)),
        parseInt(this.startTime.slice(3,5))
      )
    }
    
    /**
     * Emite evento de execução da heurística das rotas.
     */
    runHeuristic() {
      this.callHeuristic.emit();
    }
    
    /**
     * Controla interação com a lista de execuções da heurística (iterações) 
     * das rotas.
     * Na lista de iterações, pode-se escolher até duas iterações por vez.
     * 
     * @param event 
     * @param iteration 
     * @returns 
     */
    getIterationGeometries(event: Event, iteration: Iteration) {

      let target = (<HTMLInputElement> event.target);

      if (target.checked == true) {
        this.addIteration(target, iteration);
      }
      else {
        this.removeIteration(target, iteration);
      }
    }

    /**
     * Marca uma iteração para que sua rota seja exibida no mapa. 
     * Só é possível marcar duas iterações por vez,
     * para que seja viável comparar as duas rotas geradas.
     * 
     * @param target checkbox relacionado à iteração
     * @param iteration dados da iteração
     * @returns 
     */
    private addIteration(target: HTMLInputElement, iteration: Iteration) {

      if (this.currentIterations.length >= 2) {
        target.checked = false;
        return;
      }
      this.currentIterations.push(iteration.iteration_id);
      this.getHistoryGeometries.emit();
    }

    /**
     * Marca uma iteração para que sua rota seja removida do mapa.
     * 
     * @param target checkbox relacionado à iteração
     * @param iteration dados da iteração
     * @returns 
     */
    private removeIteration(target: HTMLInputElement, iteration: Iteration) {

      let index = this.currentIterations.indexOf(iteration.iteration_id);
      if (index === -1) {
        return;
      }
      this.currentIterations.splice(index, 1);
      this.getHistoryGeometries.emit();
    }
    
    /**
     * Trata a seleção de uma sessão diferente da heurística das rotas, buscando \
     * as iterações relacionadas à sessão selecionada.
     * @param event dados da sessão selecionada.
     */
    onSessionChange(event: any) {
      this.getIterationList(event.value);
    }

    priorityListDropped(event: CdkDragDrop<string[]>) {
      moveItemInArray(this.priorityList, event.previousIndex, event.currentIndex);
    }
    
    /**
     * Emite evento de limpar as rotas exibidas no mapa.
     */
    clearRoutes() {
      this.clearAllRoutes.emit();
    }
    
    /**
     * Emite evento de alternar a exibição das rotas do histórico no mapa.
     * @param event 
     */
    changeVisibilityHistoryRoutes(event: any) {
      this.showHistoryRoutes = !this.showHistoryRoutes;
      this.changeVisibilityHistoryLayer.emit();
    }
    
    /**
     * Emite evento de alternar a exibição da rota atual no mapa.
     * @param event 
     */
    changeVisibilityCurrentRoutes(event: any) {
      this.showCurrentRoutes = !this.showCurrentRoutes;
      this.changeVisibilityCurrentLayer.emit();
    }

    /**
     * Trata alteração do campo da data, copiando a data para a data limite da
     * janela de ocorrências
     */
    onDateFieldBlur() {
      this.endDate = this.startDate;
    }

    /**
     * Emite evento de exportação das camadas do mapa.
     */
    exportMap() {
      this.mapExported.emit();
    }

    /** 
     * Emite evento indicando que houve um click no botão de abrir a tabela do histórico
     * de execuções da heurística das rotas.
     */
    openRouteIterationHistoryTable() {
      this.routeIterationHistoryTableOpened.emit();
    }
}
